import { ArrowRightCircleIcon, CircleStackIcon, DocumentDuplicateIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useState } from "react";

import { Dialog } from "@fronterahealth/frontera-ui-components";

import { DataSourcesDialog } from "@pages/Templates/DataSourcesDialog";
import { Tip } from "@pages/Templates/Tip";

// --- Field Action Menu ---

export function FieldActionMenu({
  onDuplicate,
  onDelete,
  onDataSources,
  onCopy,
  currentDataSources,
  fieldTitle,
  reportType,
}: {
  onDuplicate: () => void;
  onDelete: () => void;
  onDataSources: (deps: string[]) => void;
  onCopy: () => void;
  currentDataSources: string[];
  fieldTitle: string;
  /** Report type of the template this field belongs to. Threaded
   *  through to ``DataSourcesDialog`` so the assessment-tools list
   *  scopes correctly. */
  reportType: string;
}) {
  const [dsOpen, setDsOpen] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);

  return (
    <div className="flex items-center gap-1" onClick={(e) => e.stopPropagation()}>
      <Tip text="Edit data sources">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setDsOpen(true);
          }}
          className="p-1 rounded text-text-tertiary hover:text-rio-600 hover:bg-rio-50"
        >
          <CircleStackIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Duplicate field">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onDuplicate();
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-primary hover:bg-limestone-50"
        >
          <DocumentDuplicateIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Copy field to clipboard">
        <button
          onClick={(e) => {
            e.stopPropagation();
            onCopy();
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-primary hover:bg-limestone-50"
        >
          <ArrowRightCircleIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Tip text="Delete field">
        <button
          onClick={(e) => {
            e.stopPropagation();
            setConfirmOpen(true);
          }}
          className="p-1 rounded text-text-tertiary hover:text-text-error-primary hover:bg-red-50"
        >
          <TrashIcon className="h-4 w-4" />
        </button>
      </Tip>
      <Dialog
        title={`Delete "${fieldTitle}"?`}
        open={confirmOpen}
        setOpen={(v) => {
          if (!v) setConfirmOpen(false);
        }}
        primaryButton={{
          text: "Delete",
          onClick: () => {
            onDelete();
            setConfirmOpen(false);
          },
        }}
        secondaryButton={{ text: "Cancel", onClick: () => setConfirmOpen(false) }}
        size="sm"
      >
        <p className="text-sm text-text-secondary">
          This field will be removed from the section. Save changes to make it permanent.
        </p>
      </Dialog>
      <DataSourcesDialog
        open={dsOpen}
        onClose={() => setDsOpen(false)}
        title={fieldTitle}
        current={currentDataSources}
        reportType={reportType}
        onSave={(deps) => {
          onDataSources(deps);
          setDsOpen(false);
        }}
      />
    </div>
  );
}
